/* src/app/container/container.component.scss */
:host ::ng-deep {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.pubblicazioni-list {
  flex: 1 1 0;
}
::ng-deep p-splitter {
  height: 100%;
  flex: 1 1 0;
}
::ng-deep p-splitter .p-splitter-gutter,
::ng-deep p-splitter .p-splitter-gutter-handle {
  background-color: rgba(4, 141, 79, 0.6117647059) !important;
}
::ng-deep p-splitter .splitter-pubblicazioni {
  height: 100%;
}
::ng-deep p-splitter.hiderightside .p-splitter .p-splitter-gutter {
  display: none;
}
::ng-deep p-splitter.hiderightside .p-splitter .p-splitterpanel:nth-of-type(3) {
  display: none !important;
}
.header-class {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.header-class .logo-container-albi {
  max-height: 100%;
  align-items: center;
  display: flex;
}
.header-class .logo-container-albi .logo-img-albi {
  height: 3.75rem;
  max-height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  border: round;
  margin: 0.5rem;
}
.header-class .text-green-albi {
  color: rgba(4, 141, 79, 0.6117647059) !important;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  font-weight: bold;
  font-size: 1.5em;
  border: round;
  margin: 0.5rem;
}
.p-button {
  border: 0.06remrem solid rgba(4, 141, 79, 0.6117647059) !important;
  background: rgba(4, 141, 79, 0.6117647059) !important;
}
/*# sourceMappingURL=container.component.css.map */
